__turbopack_context__.v({
  "root": "PlasmicModalCloseButton-module__9hOCya__root",
  "svg": "PlasmicModalCloseButton-module__9hOCya__svg",
});
